import React from 'react';
import { StatusBar } from 'react-native';

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';

import PaymentMethods from '../../Containers/PaymentMethods';

function PaymentMethodsScreen({ onClose, ...props }) {
  return (
    <VFScreen title="payment_method_screen_title" onClose={onClose}>
      <StatusBar backgroundColor="transparent" />
      <PaymentMethods {...props} />
    </VFScreen>
  );
}
PaymentMethodsScreen.propTypes = {
  onClose: PropTypes.func,
};
export default PaymentMethodsScreen;
